import { Input, InputGroupInput } from "@sfc/ui";
import type { ComponentProps } from "react";
import { useHasFinePointer } from "@client/hooks/use-fine-pointer";
import { isMacPlatform } from "@client/utils/platformClick";

type PageSearchInputProps = ComponentProps<typeof Input> & {
  placeholder: string;
  /** Use the existing borderless input styling inside an InputGroup. */
  inGroup?: boolean;
};

/** Page-level search only. Local pickers and embedded filters should use their own inputs. */
export function PageSearchInput({
  placeholder,
  inGroup = false,
  ...props
}: PageSearchInputProps) {
  const hasFinePointer = useHasFinePointer();
  const Component = inGroup ? InputGroupInput : Input;
  return (
    <Component
      aria-label={placeholder}
      aria-keyshortcuts="Meta+K Control+K"
      {...props}
      data-search-shortcut=""
      placeholder={
        hasFinePointer
          ? `${placeholder} (${isMacPlatform ? "⌘K" : "Ctrl+K"})`
          : placeholder
      }
    />
  );
}
